import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ThankYouPageContainer = styled("div")({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(180deg, #4b6cb7 0%, #182848 100%)",
  color: "white",
  textAlign: "center",
  padding: "20px",
});

const Title = styled("h1")({
  fontSize: "48px",
  margin: "0 0 20px 0",
  fontWeight: "bold",
});

const Subtitle = styled("h2")({
  fontSize: "24px",
  margin: "0 0 20px 0",
  fontWeight: "normal",
});

const Content = styled("p")({
  fontSize: "20px",
  lineHeight: "1.5",
  maxWidth: "600px",
  marginBottom: "30px",
});

const LogoContainer = styled(Grid)({
  justifyContent: "center",
  marginBottom: "10px",
});

const Thankyou = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    // 1. Immediately purge all session and local storage to prevent data bleeding
    sessionStorage.clear();
    localStorage.clear();

    // 2. Exit fullscreen if still active
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }

    // 3. Block back button navigation to exam
    const handleBackButtonEvent = () => {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButtonEvent);

    // 4. Auto-redirect countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
      window.removeEventListener("popstate", handleBackButtonEvent);
    };
  }, [navigate]);

  return (
    <ThankYouPageContainer>
      <LogoContainer>
        <img
          src={require("../assets/images/sunwareLogo.png")}
          alt="Company Logo"
          width="110px"
        />
      </LogoContainer>
      <Title>Thank You!</Title>
      <Subtitle>Your submission has been received</Subtitle>
      <Content>
        We appreciate you taking the time to complete the assessment. Your answers have been recorded successfully.
      </Content>

      <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "15px", marginBottom: "20px" }}>
        Auto-redirecting to login in <strong>{countdown}</strong> seconds...
      </p>

      <Button
        variant="contained"
        onClick={handleLogout}
        style={{
          backgroundColor: "#F59E0B",
          color: "#fff",
          fontWeight: 600,
          borderRadius: "30px",
          padding: "10px 30px",
          textTransform: "none",
          fontSize: "16px",
          boxShadow: "0 4px 15px rgba(245, 158, 11, 0.4)",
        }}
      >
        Finish & Logout
      </Button>

      <div style={{ position: "fixed", bottom: "10px", right: "16px", fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>
        © 2026 Sunware Technologies. All rights reserved.
      </div>
    </ThankYouPageContainer>
  );
};

export default Thankyou;
